
import { useState } from 'react';

interface HeaderProps {
  scrolled: boolean;
}

export default function Header({ scrolled }: HeaderProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const navItems = [
    { label: 'ホーム', href: '#home' },
    { label: '協会について', href: '#about' },
    { label: '事業内容', href: '#business' },
    { label: 'サービス＆プログラム', href: '#services' },
    { label: 'ペット×ウェルビーイング', href: '#pet' },
    { label: 'LED光美容 WellTerra', href: '#wellterra' },
    { label: 'お知らせ', href: '#news' },
    { label: 'お問い合わせ', href: '#contact' },
  ];

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    try {
      const element = document.querySelector(href);
      if (element) {
        const offset = 80;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
        setMobileMenuOpen(false);
      }
    } catch (error) {
      console.error('Navigation error:', error);
    }
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled ? 'bg-white/95 backdrop-blur-md shadow-md' : 'bg-white/95 backdrop-blur-sm'
        }`}
      >
        <nav className="max-w-[1400px] mx-auto px-10 h-20 flex items-center justify-between">
          {/* ロゴ */}
          <a href="#home" onClick={(e) => handleNavClick(e, '#home')} className="flex items-center cursor-pointer">
            <img
              src="https://static.readdy.ai/image/69410fb2e6bcdd872737f1aa8d7dee35/baf478bf3cc0ca3183d92ef9021d5d79.jpeg"
              alt="未来ウェルビーイング協会"
              className="h-11 w-auto transition-transform duration-300 hover:scale-105"
            />
          </a>

          {/* デスクトップナビゲーション */}
          <div className="hidden lg:flex items-center gap-8">
            {navItems.slice(0, -1).map((item) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="text-sm font-medium text-gray-700 hover:text-[#4A90E2] transition-colors duration-300 relative group whitespace-nowrap cursor-pointer"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] transition-all duration-300 group-hover:w-full"></span>
              </a>
            ))}
            <a
              href="#contact"
              onClick={(e) => handleNavClick(e, '#contact')}
              className="px-6 py-2.5 bg-gradient-to-r from-[#4A90E2] to-[#50C9C3] text-white text-sm font-semibold rounded-full hover:shadow-lg transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              お問い合わせ
            </a>
          </div>

          {/* モバイルメニューボタン */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden w-10 h-10 flex flex-col items-center justify-center gap-1.5 cursor-pointer"
            aria-label="メニュー"
          >
            <span className={`w-6 h-0.5 bg-gray-700 transition-all duration-300 ${mobileMenuOpen ? 'rotate-45 translate-y-2' : ''}`}></span>
            <span className={`w-6 h-0.5 bg-gray-700 transition-all duration-300 ${mobileMenuOpen ? 'opacity-0' : ''}`}></span>
            <span className={`w-6 h-0.5 bg-gray-700 transition-all duration-300 ${mobileMenuOpen ? '-rotate-45 -translate-y-2' : ''}`}></span>
          </button>
        </nav>
      </header>

      {/* モバイルメニュー */}
      <div
        className={`fixed inset-0 z-40 lg:hidden transition-all duration-300 ${
          mobileMenuOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
        }`}
      >
        <div
          className="absolute inset-0 bg-black/50"
          onClick={() => setMobileMenuOpen(false)}
        ></div>
        <div
          className={`absolute top-20 left-0 right-0 bg-white shadow-xl transition-transform duration-300 ${
            mobileMenuOpen ? 'translate-y-0' : '-translate-y-full'
          }`}
        >
          <div className="py-6">
            {navItems.map((item, index) => (
              <a
                key={item.label}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className={`block px-8 py-4 text-lg font-medium text-gray-700 hover:bg-gradient-to-r hover:from-[#4A90E2]/10 hover:to-[#50C9C3]/10 transition-colors duration-300 cursor-pointer ${
                  index !== navItems.length - 1 ? 'border-b border-gray-100' : ''
                }`}
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
